import { useEffect, useState } from "react";

import { type Locale, getLocale, setLocale, subscribeLocale } from "./i18n";

export function useLocale(): [Locale, (next: Locale) => void] {
  const [locale, setLocaleState] = useState<Locale>(getLocale);

  useEffect(() => subscribeLocale(setLocaleState), []);

  return [locale, setLocale];
}
